import React from 'react';
import './form.css';
import { useNavigate } from 'react-router-dom';
import { useState, useEffect, useContext } from 'react';
import { Link } from 'react-router-dom';
import SocialContext from '../../context/SocialContext';
import { CircularProgress } from '@material-ui/core';
import Alertjs from '../../components/alert/Alert';
import Topbar from '../../components/topbar/Topbar';

import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import VisibilityIcon from '@mui/icons-material/Visibility';

export default function Login() {
    const navigate = useNavigate();
    useEffect(() => {
        if (localStorage.getItem('currentUID')) {
            navigate('/');
        }
        scrolltoTopfun();
        window.document.title = 'SocialHub - Login';
    }, [])

    const { showalert, setshowalert, setalertType, setalertmessage, user, isfetching, scrolltoTopfun, iserror, setiserror, setisfetching, setuser, loginfun } = useContext(SocialContext);;

    const [email, setemail] = useState('')
    const [password, setpassword] = useState('')

    // login
    const onsubmitfun = (event) => {
        event.preventDefault();
        if (email !== "" && password !== "") {
            loginfun(email, password);
            setTimeout(() => {
                setemail("");
                setpassword("");
            }, 2000);
        }
    }

    const onclickfun = () => {
        if (email == "" && password == "") {
            setshowalert(true);
            setalertType('warning');
            setalertmessage("Please enter login credentials and try again..");
            setTimeout(() => {
                setshowalert(false);
            }, 2000);
        }
    }

    const [visible, setvisible] = useState(false);
    const [inputType, setinputType] = useState('password');
    const toggleVisiblefun = () => {
        setvisible(!visible);
        if (inputType == 'password') {
            setinputType('text')
        } else {
            setinputType('password')
        }
    }

    return (
        <>
            <Topbar />
            {showalert ? <div style={{ 'position': 'sticky', 'top': '50px', 'zIndex': '2' }}>
                <Alertjs />
            </div> : ""}
            <div className="back">
                <div className='formbody login'>
                    <div className="sign-up-form">
                        <h1>Sign In{showalert}</h1>
                        <form onSubmit={onsubmitfun}>
                            <p className='formtitle'>Email</p>
                            <input value={email} onChange={(e) => { setemail(e.target.value) }} required autoComplete='off' name="email" type="email" className='input-box' placeholder='Your Email' />
                            <p className='formtitle'>Password</p>
                            <div className='passworddiv'><input className='input-box' maxLength={12} style={{ border: 'none', margin: '0px' }} value={password} onChange={(e) => { setpassword(e.target.value) }} required autoComplete='off' name="password" minLength="4" type={inputType} placeholder='Your Password' />{visible ? <VisibilityIcon style={{ 'marginRight': '10px', opacity: '0.6' }} onClick={toggleVisiblefun} /> : <VisibilityOffIcon style={{ 'marginRight': '10px', opacity: '0.6' }} onClick={toggleVisiblefun} />}</div>
                            <button type='submit' onClick={onclickfun} id='submitbtn' className='formbutton signup-btn'>{isfetching ? <CircularProgress size="17px" /> : "Log In"}</button>
                        </form>
                        <p className='p'>Forgot Password ? <Link style={{ 'textDecoration': 'none' }} to="/reset-password">  Click Here</Link></p>
                        <hr className='formhr' />
                        <p className='p'>Don't have an account ? <Link style={{ 'textDecoration': 'none' }} to="/register">  Sign up</Link></p>
                    </div>
                </div>
                <div className="copyright" style={{'position':'fixed','bottom':'1px','width':'100%'}}>
                    <p style={{ 'textAlign': 'center', opacity: '0.9','width':'100%' }}>Copyright ©2022-Alok.info | All rights reserved</p>
                </div>
            </div>
        </>
    );
}
